<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Playlists</div>
                </div>
                <div class="col-md-3 offset-md-3 text-right center">
                    <button type="submit" class="btn btn-primary btn-fill"
                            @click="createPlaylist()">Create Corporation Playlist</button>
                </div>
            </div>
            <div class="table-responsive text-center">
                <l-table class="table table-light table-bordered table-hover"
                         :columns="playlists.columns" :data="playlists.data">
                    <template slot="table-row" v-if="playlists.data.length">
                        <tr v-for="(item, index) in playlists.data" :key="index">
                            <td>{{item.playlistId}}</td>
                          <td>{{item.csvCorporationName}}</td>
                          <td>{{item.playlistTitle}}</td>
                          <td>{{item.playlistDescription}}</td>
                          <td>{{item.videoCount}}</td>
                          <td>
                            <span class="badge badge-success" v-if="item.active != '0'"> Active </span>
                            <span class="badge badge-danger" v-else> Inactive </span>
                          </td>
                          <td>
                            <div class="btn-group" role="group">
                              <button class="btn btn-secondary btn-sm" @click="viewPlaylist(item)" v-tooltip.top-center="tooltips.view"><i class="fa fa-eye"></i></button>
                              <button class="btn btn-info btn-sm" @click="editPlaylist(item)" v-tooltip.top-center="tooltips.edit"><i class="fa fa-edit"></i></button>
                            </div>
                          </td>
                        </tr>
                    </template>
                </l-table>
            </div>
        </div>
    </div>
</template>
<script>
    import LTable from 'src/components/UIComponents/Table.vue'
    const columns = ['Playlist Id', 'Corporation', 'Title', 'Description', 'Videos', 'Active', 'Operations'];
    export default {
        name: 'Playlists',
        components: {
            LTable,
        },
        data() {
        return {
            tooltips: {
                view: 'View',
                edit: 'Edit'
            },
          playlists: {
                columns: [...columns],
        data: []
    }
    }
    },
    methods: {
        fetch () {
            this.$store.dispatch('FETCH_PLAYLISTS')
                    .then((res) => {
                        this.playlists.data = res;
                        console.log('response', res)
                        console.log("this.playlists.data : ", this.playlists.data);
                    })
                    .catch(err => {
                        console.log("API error : ", err);
                    })
        },
        viewPlaylist(item){
            this.$store.commit('SET_SELECTED_PLAYLIST', item);
            this.$router.push({ name: 'Playlist Detail', params: { id:  item.playlistId}})
        },
        editPlaylist(item){
            this.$store.commit('SET_SELECTED_PLAYLIST', item);
            this.$router.push({ name: 'Edit Playlist', params: { id: item.playlistId}});
        },
        createPlaylist(){
            this.$router.push({ name: 'Create Playlist'})
        },
    },
    created() {
        this.fetch();
    },
    computed:{
        routeName () {
            const {name} = this.$route;
            return this.capitalizeFirstLetter(name);
        }
    }
    }
</script>

<style>
    .btn-icon{
        border: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Playlists/Playlists.vue